module.exports = __webpack_public_path__ + "img/courses.102c51cc.svg";